import styled from 'styled-components'
import { Flex } from 'grid-styled'

import theme from '../../../../../../theme'

export const CardWrapper = styled(Flex)`
  flex-direction: column;
  height: 75vh;
  overflow: auto;
  background-color: #d0e2ef;
  padding: 0 50px 0 50px;
`

export const Title = styled(Flex)`
  color: ${theme.colors.black};
  width: 100%;
  flex-shrink: 0;
  justify-content: center;
  font-size: 40px;
  font-family: Montserrat;
  padding: 15px;
  text-align: center;
`

export const Tools = styled(Flex)`
  color: ${theme.colors.navy};
  width: 100%;
  flex-shrink: 0;
  justify-content: center;
  font-size: 18px;
  font-family: Montserrat;
  font-weight: bold;
  padding-bottom: 10px;
`

export const PhotoWrapper = styled(Flex)`
  justify-content: space-evenly;
  align-items: center;
  flex-shrink: 0;
`

export const Photo = styled.img`
  max-width: 400px;
  max-height: 400px;
`

export const Description = styled(Flex)`
  color: ${theme.colors.black};
  font-size: 18px;
  font-family: Montserrat;
  flex-shrink: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  white-space: pre-line;
`



// WEBPACK FOOTER //
// ./src/containers/CS/components/ProjectsCarousel/components/Card/styles.js